import React, { useEffect, useState } from 'react';
import {
  Dimensions,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  View,
  TextInput,
  FlatList,
  TouchableOpacity,
  ScrollView,
  Modal,
} from 'react-native';
import { Picker } from '@react-native-picker/picker';
import axios from 'axios';
import { Formik } from 'formik';
import * as yup from 'yup';

import { BASE_URL } from '../../../components/BaseUrl';
import LeftBar from '../../../shared/LeftBar';
import LeftBarItem from '../../../shared/LeftBarItem';
import ErrorText from '../../../shared/errorText';
import { globalStyles } from '../../../styles/globalStyles';
import SearchForm from './../../../components/BookmarkList/SearchForm';
import {
  DefaultThemeColors,
  DarkThemeColors,
  ThemeOne,
  ThemeTwo,
} from '../../../utils/constants/Colors';
import { useRoute } from '@react-navigation/native';
import LeftBarItemAdmin from '../../../shared/LeftBarItemAdmin';
const Colors2 = ThemeOne;

const windowWidth = Dimensions.get('window').width;

const basicInfoSchema = yup.object({
  division_name: yup.string().required('Division is required'),
  district_name: yup.string().required('District is required'),
  building_name_id: yup.string().required('Adalot is required'),
  gr_branch_id: yup.string().required('Lower Court is required'),
  name_bng: yup.string().required('Thana/Area name is required'),
});
// const basicInfoSearchSchema = yup.object({
//   division_name: yup.string().required('Division is required'),
//   district_name: yup.string().required('District is required'),
// });

export const OfflineDairyComponent = () => {
  const [division, setDivision] = useState([]);
  const [district, setDistrict] = useState([]);
  const [lowerCourt, setLowerCourt] = useState([]);
  const [searchLowerCourt, setSearchLowerCourt] = useState([]);

  const [division_id, setDivisionId] = useState('');
  const [district_id, setDistrictId] = useState('');
  const [searchDivision_id, setSearchDivisionId] = useState('');
  const [searchDistrict_id, setSearchDistrictId] = useState('');
  const [typeOfAalto_id, setTypeOfAaltoId] = useState(null);
  const [searchThana_id, setSearchThanaId] = useState('');
  const [searchDivisionName, setSearchDivisionName] = useState('');
  const [searchDistrict_name, setSearchDistrictName] = useState('');
  const [searchTypeOfAaltoId, setSearchTypeOfAaltoId] = useState('');
  const [thana_id, setThanaId] = useState('');
  const [lower_court_id, setLowerCourtId] = useState('');
  const [selectedLowerCourt, setSelectedLowerCourt] = useState(null);
  const [allData, setAllData] = useState([]);
 const [courtTypes, setCourtTypes] = useState([]);
  // State for edit modal
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editDivisionId, setEditDivisionId] = useState('');
  const [editDistrictId, setEditDistrictId] = useState('');
  const [editLowerCourtId, setEditLowerCourtId] = useState('');
  const [editLowerCourtName, setEditLowerCourtName] = useState('');
  const [editDistrictData, setEditDistrictData] = useState([]);
  const [editLowerCourtData, setEditLowerCourtData] = useState([]);
  const [editAdalotTypeId, setEditAdalotTypeId] = useState('');
  const route = useRoute();
  useEffect(() => {
    fetchDivisionData();
  }, []);

  const typeOfAalto = [
    {
      id: '2',
      name: 'জেলা জজ আদালত',
      office_origin_ids: [
        4, 5, 6, 7, 8, 18, 19, 20, 21, 74, 75, 76, 83, 94, 103, 105,
      ],
      type: '1',
    },
    {
      id: '3',
      name: 'চীফ জুডিসিয়াল ম্যাজিস্ট্রেট আদালত',
      office_origin_ids: [14, 15, 16, 17, 84, 85, 91, 95],
      type: '1',
    },
    {
      id: '4',
      name: 'ট্রাইবুনালসমূহ',
      office_origin_ids: [
        89, 9, 72, 73, 77, 79, 80, 81, 82, 86, 87, 96, 102, 104, 110, 111, 112,
      ],
      type: '1',
    },
  ];
  const METRO_DISTRICT_IDS = [65, 66, 67, 68, 69, 70];
  const COURT_TYPE_METRO = [
    { id: '5', name: 'মহানগর দায়রা জজ আদালত', officeOriginIds: [10, 11, 12, 88], type: '2' },
    {
      id: '6',
      name: 'চীফ মেট্রোপলিটন ম্যাজিস্ট্রেট আদালত',
      officeOriginIds: [13, 22, 23, 24, 78, 92, 100],
      type: '2',
    },
    { id: '7', name: 'বিশেষ ট্রাইব্যুনাল', officeOriginIds: [109], type: '2' },
  ];

  const updateDivision = (handleChange, value) => {
    handleChange(value);
  };

  const updateDistrict = (handleChange, e) => {
    handleChange(e);
  };
  const fetchDivisionData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/GetDivission`);
      setDivision(res.data || []);
    } catch (error) {
      console.log('Division Error:', error);
    }
  };

  const fetchDistrictData = async divisionId => {
    try {
      const formBody = `division_id=${encodeURIComponent(divisionId)}`;

      const res = await axios.post(`${BASE_URL}/DivisionToDistrict`, formBody, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      setDistrict(res.data || []);
      setDistrictId('');
      setThanaId('');
      setLowerCourtId('');
      setLowerCourt([]);
      setSelectedLowerCourt(null);
    } catch (error) {
      console.log('District Error:', error);
    }
  };

  const fetchEditDistrictData = async divisionId => {
    try {
      const formBody = `division_id=${encodeURIComponent(divisionId)}`;

      const res = await axios.post(`${BASE_URL}/DivisionToDistrict`, formBody, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      setEditDistrictData(res.data || []);
    } catch (error) {
      console.log('District Error:', error);
    }
  };

  const fetchEditLowerCourtData = async districtId => {
    try {
      const params = {
        geo_division_id: editDivisionId,
        geo_district_id: districtId,
        status: 1,
      };

      const res = await axios.get(
        `${BASE_URL}/GetGrbranchByDivisionAndDistrict`,
        {
          params,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        },
      );

      setEditLowerCourtData(res.data || []);
      setEditLowerCourtId('');
      setEditLowerCourtName('');

    } catch (error) {
      console.log('Lower Court Error:', error);
    }
  };
  const fetchLowerCourtData = async (typeOfAdalot) => {
    if (!division_id || !district_id || !typeOfAdalot) {
      console.log('Division ID or District ID missing');
      return;
    }
    setLowerCourt([])
    try {
      const response = await axios.get(
        `${BASE_URL}/GetOfflineLowerCourtByDivisionAndDistrict`,
        {
          params: {
            geo_division_id: division_id,
            geo_district_id: district_id,
            building_name_id: typeOfAdalot,
            status: 1,
          },
        }
      );
      setLowerCourt(response.data || []);
      setLowerCourtId('');
      setThanaId('');
      setSelectedLowerCourt(null);
    } catch (error) {
      console.log('Lower Court Error:', error);
      setLowerCourt([]);
    }
  };
  // Add this new function
  const searchFetchDistrictData = async divisionId => {
    try {
      const formBody = `division_id=${encodeURIComponent(divisionId)}`;
      const res = await axios.post(`${BASE_URL}/DivisionToDistrict`, formBody, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      setDistrict(res.data || []);
      setSearchDistrictId('');
      setSearchThanaId('');
      setSearchLowerCourt([]);
    } catch (error) {
      console.log('District Error:', error);
    }
  };

  // Fix this function
  const searchfetchLowerCourtData = async (typeOfAdalot) => {
    if (!searchDivision_id || !searchDistrict_id || !typeOfAdalot) {
      console.log('Division ID or District ID missing');
      return;
    }
    setSearchLowerCourt([])
    try {
      const response = await axios.get(
        `${BASE_URL}/GetOfflineLowerCourtByDivisionAndDistrict`,
        {
          params: {
            geo_division_id: searchDivision_id,
            geo_district_id: searchDistrict_id,
            building_name_id: typeOfAdalot,
            status: 1,
          },
        }
      );
      setSearchLowerCourt(response.data || []);
    } catch (error) {
      console.log('Lower Court Error:', error);
      setSearchLowerCourt([]);
    }
  };
  const fetchPoliceStationData = async districtId => {
    try {
      const params = {
        geo_division_id: searchDivision_id,
        geo_district_id: districtId,
        status: 1,
      };

      const res = await axios.get(
        `${BASE_URL}/GetGrbranchByDivisionAndDistrict`,
        {
          params,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        },
      );

      setLowerCourt(res.data || []);
      setThanaId('');
      setLowerCourtId('');
      setSelectedLowerCourt(null);

    } catch (error) {
      console.log('Lower Court Error:', error);
    }
  };

  const handleGetAllData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/GetOfflinePoliceByStationLowerCourt`);
      if (res.status == 200) {
        setAllData(res.data);
      }
    } catch (error) {
      console.log('Get All Data Error:', error);
    }
  };

  const handleSearch = async () => {
    if (!searchThana_id) {
      alert('Please select dairy name  to search');
      return;
    }
    try {
      const res = await axios.get(`${BASE_URL}/GetOfflinePoliceByStationLowerCourt`, {
        params: {
          thana_id: searchThana_id,
          status: 1,
        },
      });
      console.log('Search Response:', res);
      if (res.status == 200) {
        setAllData(res.data);
      }
    } catch (error) {
      console.log('Get All Data Error:', error);
    }
  };

  const handleSubmitForm = async () => {
    const payload = {
      offline_lower_courts_id: lower_court_id,
      name_bng: thana_id || '',
      gr_branch_id:  typeOfAalto_id|| '',
      geo_division_id: division_id,
      geo_district_id: district_id,
      status: 1,
    };

    // FIXED: Correct validation condition
    if (
      !typeOfAalto_id ||  // Changed from !offline_lower_courts_id.typeOfAalto_id
      !payload.name_bng ||
      !payload.geo_division_id ||
      !payload.geo_district_id ||
      !payload.gr_branch_id
    ) {
      alert('Please fill all required fields');
      return;
    }

    let formBody = [];
    for (let key in payload) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(payload[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }

    formBody = formBody.join('&');
    let url = `${BASE_URL}/OfflinePoliceStationSave`;

    try {
      let response = await axios.post(url, formBody);
      if (response.status === 200 || response.status === 201) {
        alert('Data added successfully');
        handleGetAllData();

        // Reset form fields
        setDivisionId('');
        setDistrictId('');
        setLowerCourtId('');
        setTypeOfAaltoId(null);  // Also reset the adalot type
        setThanaId('');  // Also reset thana name

        // Optionally reset Formik form if you have access to resetForm
        // You might want to pass resetForm as a parameter to this function
      }
    } catch (error) {
      console.log('Submit Error:', error?.response?.data || error.message);
      alert(error?.response?.data?.message || 'Error adding data');
    }
  };

  const handleUpdateStatus = async item => {
    const updatedStatus = item.status === 1 ? 0 : 1 || item.status === 0 ? 1 : 0;
    try {
      let url = `${BASE_URL}/OfflinePoliceStationToggleStatus/?status=${updatedStatus}&id=${item.id}`;
      let response = await axios.post(url);
      alert('Status updated successfully');
      handleGetAllData();
    } catch (error) {
      console.log('Update Error:', error);
      alert('Error updating status');
    }
  };

  const handleEditData = async item => {
    console.log('Edit Item:', item);
    setIsEditModalVisible(true);
    setEditId(item.id);
    setEditDivisionId(item.geo_division_id?.toString());
    setEditAdalotTypeId(item.offline_lower_courts_id?.toString()); // Add this line

    // Fetch districts for the selected division
    await fetchEditDistrictData(item.geo_division_id?.toString());
    setEditDistrictId(item.geo_district_id?.toString());

    // Fetch lower courts for the selected district
    await fetchEditLowerCourtData(item.geo_district_id?.toString());
    setEditLowerCourtId(item.gr_branch_id?.toString());
    setEditLowerCourtName(item.name_bng?.toString());
  };

  const handleUpdateData = async () => {
    if (!editLowerCourtName || !editDivisionId || !editDistrictId || !editAdalotTypeId) {
      alert('Please fill all fields');
      return;
    }

    const payload = {
      id: editId,
      offline_lower_courts_id: editAdalotTypeId,
      geo_division_id: editDivisionId,
      geo_district_id: editDistrictId,
      gr_branch_id: editLowerCourtId,
      name_bng: editLowerCourtName,
      status: 1,
    };

    let formBody = [];
    for (let key in payload) {
      let encodedKey = encodeURIComponent(key);
      let encodedValue = encodeURIComponent(payload[key]);
      formBody.push(encodedKey + '=' + encodedValue);
    }

    formBody = formBody.join('&');

    try {
      let url = `${BASE_URL}/OfflinePoliceStationUpdate`;
      let response = await axios.post(url, formBody);
      alert('Data updated successfully');
      handleCloseEditModal();
      handleGetAllData();
    } catch (error) {
      console.log('Update Error:', error);
      alert('Error updating data');
    }
  };

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    // Reset edit states
    setEditId(null);
    setEditDivisionId('');
    setEditDistrictId('');
    setEditAdalotTypeId(''); // Add this line
    setEditLowerCourtId('');
    setEditLowerCourtName('');
    setEditDistrictData([]);
    setEditLowerCourtData([]);
  };

  const renderItem = ({ item, index }) => {
    return (
      <View style={styles.card}>
        <Text style={styles.serial}>{index + 1}.</Text>

        <View style={[styles.content]}>
          <Text style={styles.name}>{item.name_bng}</Text>
          <TouchableOpacity onPress={() => handleUpdateStatus(item)}>
            <Text
              style={[
                styles.status,
                {
                  color: item.status === 1 ? '#16a34a' : '#dc2626',
                },
              ]}
            >
              {item.status === 1 ? 'Active' : 'Inactive'}
            </Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={() => handleEditData(item)}>
            <Text
              style={[
                styles.status,
                {
                  color: '#f5a905',
                },
              ]}
            >
              Edit
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  };

  return (
    <ScrollView>
      <View
        style={
          Platform.OS === 'web' && windowWidth >= 600
            ? globalStyles.mainContainerAdmin
            : globalStyles.mainContainerMobile
        }
      ><LeftBar>
          <LeftBarItemAdmin
            activeScreen={route.name}
            name="ড্যাসবোর্ড"
            stack="AdminScreen"
            screen="AdminScreen"
          />

          <LeftBarItemAdmin
            activeScreen={route.name}
            name="জি আর শাখা আদালত"
            stack="অ্যাডমিন"
            screen="grBranchAdalot"
          />

          <LeftBarItemAdmin
            activeScreen={route.name}
            name="জি আর থানা/অঞ্চল"
            stack="অ্যাডমিন"
            screen="grThanaArea"
          />

          <LeftBarItemAdmin
            activeScreen={route.name}
            name="জি আর কার্জতালিকার ছবি"
            stack="অ্যাডমিন"
            screen="grAdalotCreate"
          />

          <LeftBarItemAdmin
            activeScreen={route.name}
            name="অফলাইন আদালত"
            stack="অ্যাডমিন"
            screen="OfflineAdalot"
          />
          <LeftBarItemAdmin
            activeScreen={route.name}
            name="অফলাইন ডায়েরী"
            stack="অ্যাডমিন"
            screen="OfflineDairy"
          />
          <LeftBarItemAdmin
            activeScreen={route.name}
            name="কার্জতালিকার ছবি"
            stack="অ্যাডমিন"
            screen="AllAdalotImageCreate"
          />
        
        </LeftBar>

        <View
          style={
            Platform.OS === 'web' && windowWidth >= 600
              ? globalStyles.bodyContainer
              : globalStyles.bodyContainerMobile
          }
        >
          <View style={styles.headerContainer}>
            <Text style={styles.headerTexth}> অফলাইন ডায়েরী </Text>
          </View>
          <Formik
            initialValues={{
              building_name_id: '',
              division_name: '',
              district_name: '',
              gr_branch_id: '',
              name_bng: '',
            }}

            validationSchema={basicInfoSchema}
            onSubmit={handleSubmitForm}
          >
            {({
              handleChange,
              handleSubmit,
              setFieldValue,
              setFieldTouched,
              touched,
              errors,
            }) => (
              <>
                <View style={styles.formWrapper}>
                  {/* Division */}
                  <View style={styles.FormGroup}>
                    <View style={styles.pickerWrapper}>
                      <Picker
                        selectedValue={division_id || ''}
                        style={styles.picker}
                        onValueChange={itemValue => {
                          setDivisionId(itemValue);
                          fetchDistrictData(itemValue);
                          handleChange('division_name')(itemValue);
                          setFieldTouched('division_name', true);
                        }}
                        mode="dropdown"
                      >
                        <Picker.Item
                          label="বিভাগ নির্বাচন করুনঃ–"
                          value=""
                          color="red"
                        />
                        {division.map((item, index) => (
                          <Picker.Item
                            key={index}
                            label={item.division_name_bng?.toString()}
                            value={item.geo_division_id?.toString()}
                          />
                        ))}
                      </Picker>
                    </View>
                    {touched.division_name && errors.division_name ? (
                      <ErrorText>{errors.division_name}</ErrorText>
                    ) : null}
                  </View>

                  {/* District */}
                  <View style={styles.FormGroup}>
                    <View style={styles.pickerWrapper}>
                      <Picker
                        selectedValue={district_id || ''}
                        style={styles.picker}
                        onValueChange={itemValue => {
                          setDistrictId(itemValue);
                          setFieldTouched('district_name', true);
                          setFieldValue('districtName', itemValue, true);
                          handleChange('district_name')(itemValue);
                          setCourtTypes(
                            METRO_DISTRICT_IDS.includes(Number(itemValue))
                              ? COURT_TYPE_METRO
                              : typeOfAalto,
                          );
                        }}
                        mode="dropdown"
                      >
                        <Picker.Item
                          label="জেলা নির্বাচন করুনঃ–"
                          value=""
                          color="red"
                        />
                        {district.map((item, index) => (
                          <Picker.Item
                            key={index}
                            label={item.district_name_bng?.toString()}
                            value={item.geo_district_id?.toString()}
                          />
                        ))}
                      </Picker>
                    </View>
                    {touched.district_name && errors.district_name ? (
                      <ErrorText>{errors.district_name}</ErrorText>
                    ) : null}
                  </View>

                  {/* type of adalot */}
                  <View style={styles.FormGroup}>
                    <View style={[styles.pickerWrapper]}>
                      <Picker
                        selectedValue={
                          typeOfAalto_id ? typeOfAalto_id : '0'
                        }
                        style={styles.picker}
                        dropdownIconColor="#1e3a8a"
                        onValueChange={(itemValue, itemIndex) => {
                          setTypeOfAaltoId(itemValue);
                          setFieldTouched('building_name_id', true);
                          setFieldValue('building_name_id', itemValue, true);
                          handleChange('building_name_id')(itemValue);
                          fetchLowerCourtData(itemValue);
                        }}
                        mode="dropdown"
                      >
                        <Picker.Item
                          label="আদালতের ধরন"
                          value="0"
                          color="red"
                        />

                        {courtTypes.map((item, index) => (
                          <Picker.Item
                            key={index}
                            label={`- ${item.name}`}
                            value={item.id.toString()}
                            color="#333"
                          />
                        ))}
                      </Picker>

                      {touched.building_name_id && errors.building_name_id ? (
                        <ErrorText>{errors.building_name_id}</ErrorText>
                      ) : null}
                    </View>
                  </View>
                  <View style={styles.FormGroup}>
                    <View style={styles.pickerWrapper}>
                      <Picker
                        selectedValue={lower_court_id || ''}
                        style={styles.picker2}
                        onValueChange={itemValue => {
                          setLowerCourtId(itemValue);
                          setFieldValue('gr_branch_id', itemValue, true);
                          setFieldTouched('gr_branch_id', true);
                          handleChange('gr_branch_id')(itemValue);
                        }}
                        mode="dropdown"
                      >
                        <Picker.Item
                          label="শাখার নাম নির্বাচন করুনঃ–"
                          value=""
                          color="red"
                        />
                        {lowerCourt.map((item, index) => (
                          <Picker.Item
                            key={index}
                            label={item.office_name_bng?.toString()} // Changed from name_bng to office_name_bng
                            value={item.id?.toString()}
                          />
                        ))}
                      </Picker>
                    </View>
                    {touched.gr_branch_id && errors.gr_branch_id ? (
                      <ErrorText>{errors.gr_branch_id}</ErrorText>
                    ) : null}
                  </View>
                  <View style={styles.FormGroup}>
                    <View style={styles.inputWrapper}>
                      <TextInput
                        placeholder="থানা / অঞ্চল লিখুন "
                        placeholderTextColor="#999"
                        style={styles.textInput}
                        value={thana_id || ''}
                        onChangeText={text => {
                          setThanaId(text);
                          setFieldValue('name_bng', text, true);
                          setFieldTouched('name_bng', true);
                          handleChange('name_bng')(text);
                        }}
                      />
                    </View>
                    {touched.name_bng && errors.name_bng ? (
                      <ErrorText>{errors.name_bng}</ErrorText>
                    ) : null}
                  </View>

                  <Pressable style={styles.submitButton} onPress={handleSubmit}>
                    <Text style={styles.submitButtonText}>Add</Text>
                  </Pressable>
                </View>
              </>
            )}
          </Formik>

          <View style={styles.wrapper}>
            <Formik
              initialValues={{
                divisionName: '',
                districtName: '',
                building_name_id: '',
                gr_branch_id: '',
              }}
              validationSchema={basicInfoSchema}
              onSubmit={handleSearch}
            >
              {({
                handleChange,
                handleSubmit,
                setFieldTouched,
                setFieldValue,
                touched,
                errors,
              }) => (
                <>
                  <View
                    style={[
                      styles.formWrapper,
                      {
                        paddingVertical: 0,
                        paddingHorizontal: 0,
                        borderRadius: 0,
                        borderWidth: 'none',
                      },
                    ]}
                  >
                    {/* Division */}
                    <View style={styles.FormGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={searchDivision_id || ''}
                          style={styles.picker}
                          onValueChange={itemValue => {
                            setSearchDivisionId(itemValue);
                            fetchDistrictData(itemValue);
                            handleChange('divisionName')(itemValue);
                            setFieldTouched('divisionName', true);
                            setFieldValue('divisionName', itemValue, true);
                          }}
                          mode="dropdown"
                        >
                          <Picker.Item
                            label="বিভাগ নির্বাচন করুনঃ–"
                            value=""
                            color="red"
                          />
                          {division.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={item.division_name_bng?.toString()}
                              value={item.geo_division_id?.toString()}
                            />
                          ))}
                        </Picker>
                      </View>
                      {touched.divisionName &&
                        errors.divisionName &&
                        !searchDivision_id ? (
                        <ErrorText>{errors.division_name}</ErrorText>
                      ) : null}
                    </View>

                    {/* District */}
                    <View style={styles.FormGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={searchDistrict_id || ''}
                          style={styles.picker}
                          onValueChange={itemValue => {
                            setSearchDistrictId(itemValue);
                            setFieldTouched('districtName', true);
                            setFieldValue('districtName', itemValue, true);
                            handleChange('districtName')(itemValue);
                            setCourtTypes(
                              METRO_DISTRICT_IDS.includes(Number(itemValue))
                                ? COURT_TYPE_METRO
                                : typeOfAalto,
                            );
                          }}
                          mode="dropdown"
                        >
                          <Picker.Item
                            label="জেলা নির্বাচন করুনঃ–"
                            value=""
                            color="red"
                          />
                          {district.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={item.district_name_bng?.toString()}
                              value={item.geo_district_id?.toString()}
                            />
                          ))}
                        </Picker>
                      </View>
                      {touched.districtName &&
                        errors.districtName &&
                        !searchDistrict_id ? (
                        <ErrorText>{errors.districtName}</ErrorText>
                      ) : null}
                    </View>   

                    {/* type of adalot */}
                    <View style={styles.FormGroup}>
                      <View style={[styles.pickerWrapper]}>
                        <Picker
                          selectedValue={
                            searchTypeOfAaltoId ? searchTypeOfAaltoId : '0'
                          }
                          style={styles.picker}
                          dropdownIconColor="#1e3a8a"
                          onValueChange={(itemValue, itemIndex) => {
                            setSearchTypeOfAaltoId(itemValue);
                            setFieldTouched('building_name_id', true);
                            setFieldValue('building_name_id', itemValue, true);
                            handleChange('building_name_id')(itemValue);
                            searchfetchLowerCourtData(itemValue);
                          }}
                          mode="dropdown"
                        >
                          <Picker.Item
                            label="আদালতের ধরন"
                            value="0"
                            color="red"
                          />

                          {courtTypes.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={`- ${item.name}`}
                              value={item.id.toString()}
                              color="#333"
                            />
                          ))}
                        </Picker>

                        {touched.building_name_id && errors.building_name_id ? (
                          <ErrorText>{errors.building_name_id}</ErrorText>
                        ) : null}
                      </View>
                    </View>
                    <View style={styles.FormGroup}>
                      <View style={styles.pickerWrapper}>
                        <Picker
                          selectedValue={searchThana_id || ''}
                          style={styles.picker2}
                          onValueChange={itemValue => {
                            setSearchThanaId(itemValue);
                            setFieldTouched('gr_branch_id', true);
                            setFieldValue('gr_branch_id', itemValue, true);
                            handleChange('gr_branch_id')(itemValue);
                          }}
                          mode="dropdown"
                        >
                          <Picker.Item
                            label="শাখার নাম নির্বাচন করুনঃ–"
                            value=""
                            color="red"
                          />
                          {searchLowerCourt.map((item, index) => (
                            <Picker.Item
                              key={index}
                              label={item.office_name_bng?.toString()}
                              value={item.id?.toString()}
                            />
                          ))}
                        </Picker>
                      </View>
                      {touched.gr_branch_id && errors.gr_branch_id ? (
                        <ErrorText>{errors.gr_branch_id}</ErrorText>
                      ) : null}
                    </View>
                    <Pressable
                      style={styles.submitButton}
                      onPress={handleSearch}
                    >
                      <Text style={styles.submitButtonText}>Search</Text>
                    </Pressable>
                  </View>
                </>
              )}
            </Formik>

            <FlatList
              data={allData}
              keyExtractor={item => item.id.toString()}
              renderItem={renderItem}
              showsVerticalScrollIndicator={true}
              scrollEnabled={true}
              ListEmptyComponent={
                <View style={styles.emptyContainer}>
                  <Text style={styles.emptyText}>No data found</Text>
                </View>
              }
            />
          </View>
        </View>
      </View>

      {/* Edit Modal */}
      {/* Edit Modal */}
      <Modal
        animationType="slide"
        transparent={true}
        visible={isEditModalVisible}
        onRequestClose={handleCloseEditModal}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalContainer}>
            <Text style={styles.modalTitle}>Edit Data</Text>

            {/* Division Picker */}
            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Division</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editDivisionId || ''}
                  style={styles.modalPicker}
                  onValueChange={async itemValue => {
                    setEditDivisionId(itemValue);
                    await fetchEditDistrictData(itemValue);
                    setEditDistrictId('');
                  }}
                  mode="dropdown"
                >
                  <Picker.Item
                    label="বিভাগ নির্বাচন করুনঃ–"
                    value=""
                    color="red"
                  />
                  {division.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.division_name_bng?.toString()}
                      value={item.geo_division_id?.toString()}
                    />
                  ))}
                </Picker>
              </View>
            </View>

            {/* District Picker */}
            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>District</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editDistrictId || ''}
                  style={styles.modalPicker}
                  onValueChange={async itemValue => {
                    setEditDistrictId(itemValue);
                    await fetchEditLowerCourtData(itemValue);
                    setCourtTypes(
                      METRO_DISTRICT_IDS.includes(Number(itemValue))
                        ? COURT_TYPE_METRO
                        : typeOfAalto,
                    );
                  }}
                  mode="dropdown"
                >
                  <Picker.Item
                    label="জেলা নির্বাচন করুনঃ–"
                    value=""
                    color="red"
                  />
                  {editDistrictData.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.district_name_bng?.toString()}
                      value={item.geo_district_id?.toString()}
                    />
                  ))}
                </Picker>
              </View>
            </View>

            {/* Adalot Type Picker */}
            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>আদালতের ধরন</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editAdalotTypeId || ''}
                  style={styles.modalPicker}
                  onValueChange={itemValue => {
                    setEditAdalotTypeId(itemValue);
                  }}
                  mode="dropdown"
                >
                  <Picker.Item
                    label="আদালতের ধরন নির্বাচন করুনঃ–"
                    value=""
                    color="red"
                  />
                  {courtTypes.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.name}
                      value={item.id.toString()}
                      color="#333"
                    />
                  ))}
                </Picker>
              </View>
            </View>

            {/* Lower Court Picker */}
            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Branch Name</Text>
              <View style={styles.modalPickerWrapper}>
                <Picker
                  selectedValue={editLowerCourtId || ''}
                  style={styles.modalPicker}
                  onValueChange={itemValue => {
                    setEditLowerCourtId(itemValue);
                    const selectedCourt = editLowerCourtData.find(
                      item => item.id?.toString() === itemValue
                    );
                    setEditLowerCourtName(selectedCourt?.name_bng || '');
                  }}
                  mode="dropdown"
                >
                  <Picker.Item
                    label="শাখার নাম নির্বাচন করুনঃ–"
                    value=""
                    color="red"
                  />
                  {editLowerCourtData.map((item, index) => (
                    <Picker.Item
                      key={index}
                      label={item.name_bng?.toString()}
                      value={item.id?.toString()}
                    />
                  ))}
                </Picker>
              </View>
            </View>

            {/* Thana/Area Input */}
            <View style={styles.modalFormGroup}>
              <Text style={styles.modalLabel}>Thana / Area Name</Text>
              <View style={styles.modalInputWrapper}>
                <TextInput
                  placeholder="থানা / অঞ্চল লিখুন"
                  placeholderTextColor="#999"
                  style={styles.modalTextInput}
                  value={editLowerCourtName}
                  onChangeText={setEditLowerCourtName}
                  editable={true}
                />
              </View>
            </View>

            {/* Modal Buttons */}
            <View style={styles.modalButtonContainer}>
              <TouchableOpacity
                style={[styles.modalButton, styles.cancelButton]}
                onPress={handleCloseEditModal}
              >
                <Text style={styles.cancelButtonText}>Cancel</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.modalButton, styles.updateButton]}
                onPress={handleUpdateData}
              >
                <Text style={styles.updateButtonText}>Update</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    marginTop: 15,
    marginHorizontal: 10,
  },
  headerTexth: {
    fontSize: 20,
    fontWeight: 'bold',
    color: Colors2.top5,
    textAlign: 'left',
    marginLeft: 10,
  },
  formWrapper: {
    width: '96%',
    marginLeft: '2%',
    marginTop: 12,
    marginBottom: 12,
    paddingVertical: 24,
    paddingHorizontal: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    backgroundColor: '#ffffff',
    borderRadius: 18,
    borderWidth: 1,
    borderColor: '#e8eefc',
    shadowColor: '#0f172a',
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.08,
    shadowRadius: 20,
    elevation: 8,
  },
  FormGroup: {
    marginBottom: 14,
    marginHorizontal: 8,
  },
  pickerWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 4,
    backgroundColor: '#fff',
    overflow: 'hidden',
    height: Platform.OS === 'web' && windowWidth >= 600 ? 30 : 30,
  },
  picker: {
    height: Platform.OS === 'web' && windowWidth >= 600 ? 42 : 50,
    width: '100%',
    color: '#333',
  },
  picker2: {
    height: Platform.OS === 'web' && windowWidth >= 600 ? 42 : 50,
    width: '100%',
    color: '#333',
  },
  submitButton: {
    backgroundColor: '#007bff',
    paddingVertical: 5,
    paddingHorizontal: 24,
    borderRadius: 4,
    alignSelf: 'flex-start',
    marginLeft: '2%',
  },
  submitButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
  inputWrapper: {
    borderWidth: 2,
    borderColor: '#000',
    borderRadius: 4,
    backgroundColor: '#fff',
    height: 30,
    justifyContent: 'center',
    paddingHorizontal: 0,
  },
  textInput: {
    width: '100%',
    height: 40,
    color: '#333',
    fontSize: 14,
    paddingHorizontal: 8,
  },
  wrapper: {
    width: '96%',
    marginLeft: '2%',
    marginTop: 24,
    marginBottom: 20,
    paddingVertical: 20,
    paddingHorizontal: 16,
    backgroundColor: '#fff',
    borderRadius: 18,
    borderWidth: 1,
    borderColor: '#e8eefc',
    shadowColor: '#0f172a',
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.08,
    shadowRadius: 20,
    elevation: 8,
  },
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 14,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderColor: '#e5e7eb',
    borderRadius: 10,
    marginBottom: 10,
    backgroundColor: '#fff',
  },
  serial: {
    fontSize: 15,
    fontWeight: '700',
    color: '#111827',
    width: 30,
  },
  content: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10,
  },
  name: {
    flex: 1,
    fontSize: 15,
    color: '#111827',
    fontWeight: '500',
    marginRight: 10,
  },
  status: {
    fontSize: 14,
    fontWeight: '700',
  },

  // Modal Styles
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: '#fff',
    borderRadius: 20,
    padding: 20,
    width: '90%',
    maxWidth: 500,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
    color: '#333',
  },
  modalFormGroup: {
    marginBottom: 15,
  },
  modalLabel: {
    fontSize: 14,
    fontWeight: '600',
    marginBottom: 5,
    color: '#333',
  },
  modalPickerWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 8,
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  modalPicker: {
    height: 50,
    width: '100%',
    color: '#333',
  },
  modalInputWrapper: {
    borderWidth: 1,
    borderColor: '#000',
    borderRadius: 8,
    backgroundColor: '#fff',
  },
  modalTextInput: {
    height: 50,
    paddingHorizontal: 12,
    fontSize: 16,
    color: '#333',
  },
  modalButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    gap: 10,
  },
  modalButton: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  cancelButton: {
    backgroundColor: '#f5f5f5',
    borderWidth: 1,
    borderColor: '#ddd',
  },
  cancelButtonText: {
    color: '#666',
    fontSize: 16,
    fontWeight: '600',
  },
  updateButton: {
    backgroundColor: '#007bff',
  },
  updateButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 50,
  },
  emptyText: {
    fontSize: 16,
    color: '#999',
    fontWeight: '500',
  },
});
